/**
 * Feature flag: The experiment we are implementing (usually the Epic number).
 * This is a placeholder for the feature flag that will be used in the Split.io.
 * We will need to create this feature flag in Split.io once we agree on experiment plan.
 */
export enum SplitIoFeatureFlags {
  KK425 = 'KK-425-TEST',
}

/**
 * Flag sets: Can be described as a group of feature flags for a workspace ( here: page).
 */
export const favouritesFlagSet = ['favourites'];
